import url from 'url';

export const fetchUser = async () => {
    const apiHost = process.env.API_HOST || '';
    const userEndpoint = url.parse(`${apiHost}/api/2/user`);
    const requestUrl = url.format(userEndpoint);

    const options = {
        method: 'GET',
        credentials: 'include',
    };

    const response = await fetch(requestUrl, options);
    if (response.status === 200 || response.status === 304) {
        return await response.json();
    }
};
